window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.clima = {
    // State
    data: {
        registros: [],
        forecast: null,
        current: null
    },
    activeTab: 'visao-geral', // 'visao-geral', 'registro', 'previsoes', 'mapas'
    container: null,
    chartInstance: null,

    // --- MAIN RENDER ---
    render: function (container) {
        this.container = container;

        // CSS Styles for Clima Module
        const styles = `
            <style>
                .clima-tab-nav { display: flex; gap: 5px; border-bottom: 2px solid #e2e8f0; margin-bottom: 25px; overflow-x: auto; }
                .clima-tab-btn { padding: 12px 20px; background: none; border: none; font-weight: 600; color: #64748b; cursor: pointer; font-size: 1rem; border-bottom: 3px solid transparent; margin-bottom: -2px; transition: all 0.2s; white-space: nowrap; display: flex; align-items: center; gap: 8px; }
                .clima-tab-btn:hover { color: var(--color-primary); }
                .clima-tab-btn.active { color: var(--color-primary); border-bottom-color: var(--color-primary); }
                
                .clima-card { background: white; border-radius: 12px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 20px; border: 1px solid #e2e8f0; }
                
                .metric-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 20px; }
                .metric-card { background: white; padding: 20px; border-radius: 10px; border-left: 4px solid var(--color-primary); box-shadow: 0 2px 4px rgba(0,0,0,0.02); border: 1px solid #f1f5f9; }
                .metric-title { font-size: 0.85rem; color: #64748b; font-weight: 600; text-transform: uppercase; }
                .metric-value { font-size: 1.8rem; font-weight: 700; color: #1e293b; margin: 5px 0; }
                
                .semaforo-card { background: linear-gradient(135deg, #94a3b8, #64748b); color: white; padding: 20px 30px; border-radius: 12px; display: flex; align-items: center; justify-content: space-between; margin-bottom: 25px; transition: background 0.5s; }
                .semaforo-card.verde { background: linear-gradient(135deg, #10b981, #059669); }
                .semaforo-card.amarelo { background: linear-gradient(135deg, #f59e0b, #d97706); }
                .semaforo-card.vermelho { background: linear-gradient(135deg, #ef4444, #b91c1c); }
            </style>
        `;

        container.innerHTML = styles + `
            <div id="clima-module" style="max-width: 1200px; margin: 0 auto; padding-bottom: 50px;">
                
                <!-- HEADER -->
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                    <div>
                        <h2 style="margin:0; color:#0f172a;"><i class="fas fa-cloud-sun-rain" style="color:var(--color-primary);"></i> Clima & Pluviometria</h2>
                        <p style="margin:5px 0 0 0; color:#64748b;">Fazenda Rio do Peixe e Fartura</p>
                    </div>
                    <div style="text-align:right;">
                        <div id="header-temp-val" style="font-size:1.5rem; font-weight:bold; color:#0f172a;">--°C <i class="fas fa-cloud"></i></div>
                        <div style="color:#64748b; font-size:0.9rem;">Catalão - GO</div>
                    </div>
                </div>

                <!-- TABS -->
                <nav class="clima-tab-nav">
                    <button class="clima-tab-btn active" onclick="window.FazendaRP.Pages.clima.switchTab('visao-geral')"><i class="fas fa-chart-pie"></i> Visão Geral</button>
                    <button class="clima-tab-btn" onclick="window.FazendaRP.Pages.clima.switchTab('registro')"><i class="fas fa-edit"></i> Registro</button>
                    <button class="clima-tab-btn" onclick="window.FazendaRP.Pages.clima.switchTab('previsoes')"><i class="fas fa-calendar-alt"></i> Previsões Detalhadas</button>
                    <button class="clima-tab-btn" onclick="window.FazendaRP.Pages.clima.switchTab('mapas')"><i class="fas fa-map-marked-alt"></i> Mapa (Satélite/Chuva)</button>
                </nav>

                <!-- CONTENT CONTAINERS -->
                <div id="tab-visao-geral" class="clima-tab-content"></div>
                <div id="tab-registro" class="clima-tab-content" style="display:none;"></div>
                <div id="tab-previsoes" class="clima-tab-content" style="display:none;"></div>
                <div id="tab-mapas" class="clima-tab-content" style="display:none;"></div>

            </div>
        `;

        // Render Initial Tab
        this.switchTab(this.activeTab);
        this.loadData(); // Fetch global data
    },

    switchTab: function (tabId) {
        this.activeTab = tabId;

        // Update Nav
        document.querySelectorAll('.clima-tab-btn').forEach(btn => btn.classList.remove('active'));
        const activeBtn = document.querySelector(`.clima-tab-btn[onclick*="${tabId}"]`);
        if (activeBtn) activeBtn.classList.add('active');

        // Toggle Content
        document.querySelectorAll('.clima-tab-content').forEach(el => el.style.display = 'none');
        const target = document.getElementById('tab-' + tabId);
        if (target) {
            target.style.display = 'block';
            this.renderTabContent(tabId, target);
        }
    },

    renderTabContent: function (tabId, container) {
        // Only render if empty to avoid re-rendering on switch (preserve state)
        // EXCEPTION: Dashboard might need refresh
        if (container.innerHTML.trim() !== '' && tabId !== 'visao-geral') return;

        switch (tabId) {
            case 'visao-geral':
                this.renderDashboard(container);
                break;
            case 'registro':
                this.renderRegistro(container);
                break;
            case 'previsoes':
                this.renderPrevisoes(container);
                break;
            case 'mapas':
                this.renderMapas(container);
                break;
        }
    },

    // --- DATA LOADING ---
    loadData: async function () {
        console.log("Clima: Carregando dados...");

        // 1. Fetch Weather (Forecast & Current)
        this.fetchWeather();

        // 2. Fetch Supabase Data
        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('clima_pluviometria')
                .select('*')
                .order('data_registro', { ascending: false });

            if (error) throw error;

            this.data.registros = data || [];

            // Refresh dashboards if active
            if (this.activeTab === 'visao-geral') this.renderDashboard(document.getElementById('tab-visao-geral'));
            if (this.activeTab === 'registro') this.renderRegistro(document.getElementById('tab-registro'));

        } catch (err) {
            console.error(err);
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao carregar registros: ' + err.message);
        }
    },

    fetchWeather: async function () {
        try {
            // Catalão - GO: -18.1658, -47.9425
            // Fetching GFS and ECMWF for comparison
            // Open-Meteo allows multiple models. We will fetch 'best_match' (default) and 'gfs_seamless' explicitly for comparison if needed, 
            // but to keep it simple and robust, let's fetch GFS specifically to compare with the default (which is usually a mix or ECMWF in SA).
            // Let's get both explicitly to be sure: models=ecmwf_ifs04,gfs_seamless

            const res = await fetch('https://api.open-meteo.com/v1/forecast?latitude=-18.1658&longitude=-47.9425&current_weather=true&hourly=temperature_2m,precipitation_probability,rain&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max&models=ecmwf_ifs04,gfs_seamless,best_match&timezone=America%2FSao_Paulo');
            const data = await res.json();

            // Open-Meteo with multiple models returns an array of results or nested objects? 
            // Actually, the CSV/JSON structure changes when 'models' is provided with multiple values?
            // No, Open-Meteo returns distinct arrays with suffix usually, OR we have to make separate calls?
            // Documentation says: "If multiple models are selected, the response will contain arrays for each model." 
            // Actually, simpler to just use the standard endpoint which is "Auto/Best Match" and ADD a separate call for GFS if we want to compare.
            // BUT the user prompt says "Open-Meteo... simplificam o acesso aos dados do GFS".

            // Let's try getting GFS specifically.
            const resGFS = await fetch('https://api.open-meteo.com/v1/forecast?latitude=-18.1658&longitude=-47.9425&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max&forecast_days=16&models=gfs_seamless&timezone=America%2FSao_Paulo');
            const dataGFS = await resGFS.json();

            // Default (Best Match / ECMWF usually in SA)
            // We use the first call for Current Weather + Default Forecast
            const resDefault = await fetch('https://api.open-meteo.com/v1/forecast?latitude=-18.1658&longitude=-47.9425&current_weather=true&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max&forecast_days=16&timezone=America%2FSao_Paulo');
            const dataDefault = await resDefault.json();

            this.data.forecast = dataDefault;
            this.data.forecastGFS = dataGFS;

            if (dataDefault.current_weather) {
                // Update Header
                const temp = dataDefault.current_weather.temperature;
                document.getElementById('header-temp-val').innerHTML = `${temp}°C <i class="fas fa-cloud"></i>`;

                // Update Semáforo logic if dashboard is open
                if (this.activeTab === 'visao-geral') {
                    this.updateSemaforo(dataDefault.current_weather);
                }
            }
        } catch (e) {
            console.error("Weather Fetch Error:", e);
        }
    },

    // --- 1. VISÃO GERAL ---
    renderDashboard: function (container) {
        // Calculate Metrics
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        // Safra Start: Setembro (Month 8 - 0 indexed)
        // If current month < 8 (Jan-Aug), Safra started Set previous year. Else Set current year.
        const safraStartYear = currentMonth < 8 ? currentYear - 1 : currentYear;
        const safraStartDate = new Date(safraStartYear, 8, 1); // 1st Sept

        let monthRain = 0;
        let safraRain = 0;
        let lastRainDate = null;

        this.data.registros.forEach(r => {
            const d = new Date(r.data_registro);
            const mm = parseFloat(r.milimetros);

            // Month Accumulator
            if (d.getMonth() === currentMonth && d.getFullYear() === currentYear) {
                monthRain += mm;
            }

            // Safra Accumulator
            if (d >= safraStartDate) {
                safraRain += mm;
            }

            // Find last rain > 0
            if (mm > 0) {
                if (!lastRainDate || d > lastRainDate) lastRainDate = d;
            }
        });

        // Days without rain
        let daysNoRain = '-';
        if (lastRainDate) {
            const diffTime = Math.abs(now - lastRainDate);
            daysNoRain = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        }

        const html = `
            <!-- Semáforo de Pulverização -->
            <div id="semaforo-widget" class="semaforo-card">
                <div style="text-align:left;">
                    <div style="font-size:0.9rem; opacity:0.9; text-transform:uppercase; font-weight:600;">Condições de Pulverização</div>
                    <div id="semaforo-status" style="font-size:2rem; font-weight:800; margin:5px 0;">AGUARDANDO DADOS...</div>
                    <div id="semaforo-details" style="font-size:0.9rem; opacity:0.9;">--</div>
                </div>
                <div>
                    <i class="fas fa-spray-can" style="font-size:3.5rem; opacity:0.8;"></i>
                </div>
            </div>

            <!-- Métricas -->
            <div class="metric-grid">
                <div class="metric-card">
                    <div class="metric-title">Chuva (Mês Atual)</div>
                    <div class="metric-value" style="color:#0ea5e9;">${monthRain.toFixed(1)} mm</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Em ${now.toLocaleString('default', { month: 'long' })}</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Acumulado Safra</div>
                    <div class="metric-value" style="color:#059669;">${safraRain.toFixed(1)} mm</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Desde Set/${safraStartYear}</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Dias s/ Chuva</div>
                    <div class="metric-value" style="color:#f59e0b;">${daysNoRain} dias</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Seca Recente</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Previsão Hoje</div>
                    <div class="metric-value" id="dash-forecast-today" style="font-size:1.5rem;">--</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Catalão - GO</div>
                </div>
            </div>

            <!-- Gráfico Histórico -->
            <div class="clima-card">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom: 20px;">
                     <h4 style="margin: 0; color: #374151;">Histórico de Precipitação</h4>
                     <select id="filtro-ano-chart" class="form-control" style="width: 120px; font-size: 0.9rem; padding:5px; border-radius:4px; border:1px solid #d1d5db;">
                        <!-- JS fills this -->
                     </select>
                </div>
                <div style="height: 350px; position: relative;">
                    <canvas id="chart-pluviometria"></canvas>
                </div>
            </div>
        `;

        container.innerHTML = html;

        // Init Chart
        this.initChartControls();

        // Render forecast mini if available
        if (this.data.forecast) {
            this.updateSemaforo(this.data.forecast.current_weather);

            // Forecast Today
            const daily = this.data.forecast.daily;
            if (daily) {
                const max = daily.temperature_2m_max[0];
                const min = daily.temperature_2m_min[0];
                const rainProb = daily.precipitation_probability_max[0];
                document.getElementById('dash-forecast-today').innerHTML = `
                    <span style="color:#ef4444;">${max}°</span> / <span style="color:#3b82f6;">${min}°</span>
                    <span style="font-size:0.9rem; display:block; color:#0ea5e9;"><i class="fas fa-umbrella"></i> ${rainProb}%</span>
                 `;
            }
        }
    },

    updateSemaforo: function (current) {
        if (!current) return;
        const elCard = document.getElementById('semaforo-widget');
        const elStatus = document.getElementById('semaforo-status');
        const elDetails = document.getElementById('semaforo-details');

        if (!elCard) return;

        const wind = current.windspeed; // km/h
        const temp = current.temperature; // C

        let status = 'FAVORÁVEL';
        let colorClass = 'verde';

        // Regras Básicas de Pulverização
        // Ideal: Vento 3-10 km/h, Temp < 30C
        // Ruim: Vento > 12 km/h (Deriva), Temp > 32C (Evaporação)
        // Ruim: Vento < 2 km/h (Inversão térmica - perigoso também)

        if (wind > 15 || temp > 32) {
            status = 'NÃO RECOMENDADO 🔴';
            colorClass = 'vermelho';
        } else if ((wind > 10 && wind <= 15) || (temp > 30 && temp <= 32) || wind < 2) {
            status = 'ATENÇÃO 🟡';
            colorClass = 'amarelo';
        } else {
            status = 'FAVORÁVEL 🟢';
            colorClass = 'verde';
        }

        // Remove old classes
        elCard.classList.remove('verde', 'amarelo', 'vermelho');
        elCard.classList.add(colorClass);

        elStatus.innerText = status;
        elDetails.innerHTML = `Vento: <strong>${wind} km/h</strong> | Temp: <strong>${temp}°C</strong>`;
    },

    initChartControls: function () {
        const yearSelect = document.getElementById('filtro-ano-chart');
        if (!yearSelect) return;

        const currentYear = new Date().getFullYear();
        yearSelect.innerHTML = '';
        for (let i = 0; i < 5; i++) {
            const y = currentYear - i;
            const opt = document.createElement('option');
            opt.value = y;
            opt.innerText = y;
            yearSelect.appendChild(opt);
        }
        yearSelect.value = currentYear;

        yearSelect.addEventListener('change', () => {
            this.renderChart(parseInt(yearSelect.value));
        });

        // Initial Render
        this.renderChart(currentYear);
    },

    renderChart: function (selectedYear) {
        const ctx = document.getElementById('chart-pluviometria');
        if (!ctx) return;

        if (this.chartInstance) this.chartInstance.destroy();

        const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        // Data processing
        const currentData = new Array(12).fill(0);
        this.data.registros
            .filter(r => new Date(r.data_registro).getUTCFullYear() === selectedYear)
            .forEach(r => currentData[new Date(r.data_registro).getUTCMonth()] += parseFloat(r.milimetros));

        const lastYear = selectedYear - 1;
        const lastYearData = new Array(12).fill(0);
        this.data.registros
            .filter(r => new Date(r.data_registro).getUTCFullYear() === lastYear)
            .forEach(r => lastYearData[new Date(r.data_registro).getUTCMonth()] += parseFloat(r.milimetros));

        const avgData = [272, 277, 246, 150, 73, 24, 7, 6, 32, 149, 308, 268]; // Catalão History

        this.chartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: months,
                datasets: [
                    { label: `Chuva ${selectedYear}`, data: currentData, backgroundColor: 'rgba(59, 130, 246, 0.6)', borderColor: 'rgba(59, 130, 246, 1)', borderWidth: 1, order: 2 },
                    { type: 'line', label: `Chuva ${lastYear}`, data: lastYearData, borderColor: '#fbbf24', backgroundColor: '#fbbf24', borderWidth: 2, tension: 0.3, pointRadius: 3, order: 1 },
                    { type: 'line', label: 'Média Histórica', data: avgData, borderColor: '#9ca3af', backgroundColor: '#9ca3af', borderWidth: 2, borderDash: [5, 5], tension: 0.3, pointRadius: 0, order: 0 }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'top' }, tooltip: { callbacks: { label: (c) => (c.dataset.label || '') + ': ' + c.parsed.y.toFixed(1) + ' mm' } } },
                scales: { y: { beginAtZero: true, title: { display: true, text: 'Milímetros (mm)' } } }
            }
        });
    },

    // --- 2. REGISTRO ---
    renderRegistro: function (container) {
        // Fix: Use Local Date for default value instead of toISOString (which is UTC)
        const now = new Date();
        const today = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');

        container.innerHTML = `
            <div style="display:grid; grid-template-columns: minmax(300px, 1fr) 2fr; gap:20px;">
                <!-- Form -->
                <div class="clima-card">
                    <h4 style="margin:0 0 20px 0; color:#374151; border-bottom:1px solid #f1f5f9; padding-bottom:10px;">
                        <i class="fas fa-plus-circle" style="color:#0ea5e9;"></i> Novo Registro
                    </h4>
                    <form id="form-pluviometria">
                        <div style="margin-bottom:15px;">
                            <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem;">Data</label>
                            <input type="date" id="input-data-chuva" class="form-control" value="${today}" required style="width:100%; padding:8px; border:1px solid #cbd5e1; border-radius:6px;">
                        </div>
                        <div style="margin-bottom:15px;">
                            <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem;">Local / Pluviômetro</label>
                            <select id="input-local-chuva" style="width:100%; padding:8px; border:1px solid #cbd5e1; border-radius:6px;">
                                <option value="Sede">Sede (Principal)</option>
                                <option value="Retiro">Retiro</option>
                                <option value="Pivô Central">Pivô Central</option>
                            </select>
                        </div>
                        <div style="margin-bottom:20px;">
                            <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem;">Milímetros (mm)</label>
                            <input type="number" id="input-mm-chuva" step="0.1" class="form-control" placeholder="0.0" required style="width:100%; padding:8px; border:1px solid #cbd5e1; border-radius:6px;">
                        </div>
                        <div style="margin-bottom:20px;">
                            <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem;">Observação (Opcional)</label>
                            <input type="text" id="input-obs-chuva" class="form-control" placeholder="Ex: Granizo, Vento forte..." style="width:100%; padding:8px; border:1px solid #cbd5e1; border-radius:6px;">
                        </div>
                        <button type="submit" style="width:100%; padding:12px; background:var(--color-primary); color:white; border:none; border-radius:6px; font-weight:bold; cursor:pointer;">
                            <i class="fas fa-save"></i> Salvar Registro
                        </button>
                    </form>
                </div>
                
                <!-- List -->
                <div class="clima-card">
                    <h4 style="margin:0 0 20px 0; color:#374151;"><i class="fas fa-list"></i> Últimos Registros</h4>
                    <div style="overflow-x:auto;">
                        <table style="width:100%; text-align:left; border-collapse:collapse;">
                            <thead>
                                <tr style="border-bottom:2px solid #e2e8f0; color:#64748b; font-size:0.9rem;">
                                    <th style="padding:10px;">Data</th>
                                    <th style="padding:10px;">Local</th>
                                    <th style="padding:10px;">Volume</th>
                                    <th style="padding:10px;">Obs</th>
                                    <th style="padding:10px;">Ações</th>
                                </tr>
                            </thead>
                            <tbody id="tbody-pluviometria-list"></tbody>
                        </table>
                    </div>
                </div>
            </div>
        `;

        this.renderList();

        document.getElementById('form-pluviometria').addEventListener('submit', async (e) => {
            e.preventDefault();
            await this.saveRegistro();
        });
    },

    renderList: function () {
        const tbody = document.getElementById('tbody-pluviometria-list');
        if (!tbody) return;

        if (this.data.registros.length === 0) {
            tbody.innerHTML = '<tr><td colspan="4" style="text-align:center; padding:20px; color:#94a3b8;">Nenhum registro encontrado.</td></tr>';
            return;
        }

        tbody.innerHTML = this.data.registros.slice(0, 50).map(r => {
            // Fix: Append T12:00:00 to prevent Timezone shift when parsing YYYY-MM-DD
            const displayDate = new Date(r.data_registro + 'T12:00:00').toLocaleDateString('pt-BR');

            return `
            <tr style="border-bottom:1px solid #f1f5f9;">
                <td style="padding:10px;">${displayDate}</td>
                <td style="padding:10px;">${r.local || 'Sede'}</td>
                <td style="padding:10px; font-weight:bold; color:#0ea5e9;">${parseFloat(r.milimetros).toFixed(1)} mm</td>
                <td style="padding:10px; color:#64748b; font-size:0.9rem;">${r.observacao || '-'}</td>
                <td style="padding:10px;">
                    <button onclick="window.FazendaRP.Pages.clima.deleteRegistro('${r.id}')" style="border:none; background:none; color:#ef4444; cursor:pointer;" title="Excluir">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
            </tr>
            `;
        }).join('');
    },

    saveRegistro: async function () {
        const dataInput = document.getElementById('input-data-chuva').value;
        const localInput = document.getElementById('input-local-chuva').value;
        const mmInput = document.getElementById('input-mm-chuva').value;
        const obsInput = document.getElementById('input-obs-chuva').value;

        try {
            window.FazendaRP.Toast.show('info', 'Salvando...', 'Aguarde...');

            const { error } = await window.FazendaRP.supabase
                .from('clima_pluviometria')
                .insert([{
                    data_registro: dataInput,
                    milimetros: parseFloat(mmInput),
                    local: localInput,
                    observacao: obsInput
                }]);

            if (error) throw error;

            window.FazendaRP.Toast.show('success', 'Sucesso', 'Registro salvo!');
            document.getElementById('input-mm-chuva').value = '';
            document.getElementById('input-obs-chuva').value = '';

            await this.loadData();
            this.renderList();

        } catch (err) {
            alert('Erro: ' + err.message);
        }
    },

    deleteRegistro: async function (id) {
        if (!confirm('Excluir este registro?')) return;
        try {
            await window.FazendaRP.supabase.from('clima_pluviometria').delete().eq('id', id);
            window.FazendaRP.Toast.show('success', 'Removido', 'Registro excluído');
            await this.loadData();
            this.renderList(); // Refresh list if on tab
        } catch (err) {
            alert('Erro: ' + err.message);
        }
    },

    // --- 3. PREVISÕES ---
    renderPrevisoes: function (container) {
        if (!this.data.forecast || !this.data.forecastGFS) {
            container.innerHTML = '<div style="padding:40px; text-align:center;"><i class="fas fa-spinner fa-spin"></i> Carregando modelos meteorológicos...</div>';
            return;
        }

        const daily = this.data.forecast.daily;
        const dailyGFS = this.data.forecastGFS.daily;

        if (!daily || !dailyGFS) {
            container.innerHTML = 'Dados indisponíveis.';
            return;
        }

        // --- Render Comparison Cards ---
        // We will show: Day | Best Match (ECMWF) | GFS (NOAA)

        let htmlItems = '';

        for (let i = 0; i < daily.time.length; i++) {
            const date = new Date(daily.time[i]);
            const weekDay = date.toLocaleDateString('pt-BR', { weekday: 'short' }).toUpperCase();
            const shortDate = date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });

            // Default (Best Match)
            const rainSum = daily.precipitation_sum[i];
            const rainProb = daily.precipitation_probability_max[i];
            const max = Math.round(daily.temperature_2m_max[i]);
            const min = Math.round(daily.temperature_2m_min[i]);

            // GFS
            const rainSumGFS = dailyGFS.precipitation_sum[i];
            const rainProbGFS = dailyGFS.precipitation_probability_max[i];
            // const maxGFS = Math.round(dailyGFS.temperature_2m_max[i]); // Usually temps align well, focus differences on rain

            // Logic for Icon
            let iconClass = 'fa-sun';
            let color = '#f59e0b';
            if (rainProb > 50) { iconClass = 'fa-cloud-rain'; color = '#3b82f6'; }

            // Divergence Alert?
            let gfsLabelColor = '#64748b';
            if (Math.abs(rainSum - rainSumGFS) > 5) gfsLabelColor = '#f59e0b'; // Highlight if diff > 5mm

            htmlItems += `
                <div class="clima-card" style="min-width: 160px; text-align:center; padding: 15px;">
                    <div style="font-weight:bold; color:#1e293b; margin-bottom:5px;">${weekDay} <small style="font-weight:normal; color:#94a3b8;">${shortDate}</small></div>
                    
                    <div style="margin: 10px 0;">
                        <i class="fas ${iconClass}" style="font-size: 2rem; color:${color};"></i>
                    </div>

                    <div style="font-size:1.1rem; font-weight:800; color:#334155;">${max}° <small style="color:#94a3b8; font-weight:400;">${min}°</small></div>
                    
                    <div style="margin-top:15px; border-top:1px solid #f1f5f9; padding-top:10px; text-align:left; font-size:0.85rem;">
                        <div style="margin-bottom:5px;">
                            <span style="display:inline-block; width:8px; height:8px; background:#3b82f6; border-radius:50%;"></span> 
                            <strong>ECMWF:</strong> ${rainSum}mm (${rainProb}%)
                        </div>
                        <div style="color:${gfsLabelColor};">
                            <span style="display:inline-block; width:8px; height:8px; background:#64748b; border-radius:50%;"></span> 
                            <strong>GFS:</strong> ${rainSumGFS}mm (${rainProbGFS}%)
                        </div>
                    </div>
                </div>
            `;
        }

        container.innerHTML = `
            <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:15px;">
                <h4 style="margin:0; color:#374151;">Comparativo de Modelos (ECMWF vs GFS) - 16 Dias</h4>
                <div style="font-size:0.8rem; color:#64748b;">
                    <span style="margin-right:15px;"><span style="color:#3b82f6;">●</span> Padrão (ECMWF)</span>
                    <span><span style="color:#64748b;">●</span> GFS (NOAA)</span>
                </div>
            </div>
            
            <div style="display:flex; gap:15px; overflow-x:auto; padding-bottom:10px;">
                ${htmlItems}
            </div>
            
            <div class="clima-card" style="margin-top:20px;">
                <h5 style="margin:0 0 10px 0;">Análise de Divergência</h5>
                <p style="color:#64748b; font-size:0.9rem; margin:0;">
                    Comparamos automaticamente os modelos Europeu (ECMWF) e Americano (GFS/NOAA). 
                    Quando os valores de chuva diferem muito, isso indica maior incerteza na previsão.
                </p>
            </div>
        `;
    },

    // --- 4. MAPAS ---
    renderMapas: function (container) {
        // State for Maps
        let currentProvider = 'windy'; // windy, ventusky, zoom
        let currentModel = 'ecmwf';
        let currentOverlay = 'rain'; // rain, wind, temp

        const updateMap = () => {
            const iframe = document.getElementById('windy-iframe');
            const fallback = document.getElementById('zoom-earth-fallback');
            if (!iframe || !fallback) return;

            const lat = -18.166;
            const lon = -47.943;

            // Reset
            iframe.style.display = 'block';
            fallback.style.display = 'none';

            console.log(`[Clima] Atualizando mapa: Provider=${currentProvider}, Layer=${currentOverlay}`);

            // Force reload hack
            iframe.src = 'about:blank';

            setTimeout(() => {
                if (currentProvider === 'windy') {
                    // Windy default mappings
                    let wOverlay = currentOverlay;
                    if (currentOverlay === 'rain24' || currentOverlay === 'rainTotal') wOverlay = 'rainAccu'; // Windy groups accumulation
                    if (currentOverlay === 'satellite') wOverlay = 'satellite';

                    iframe.src = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=5&overlay=${wOverlay}&product=${currentModel}&level=surface&lat=${lat}&lon=${lon}`;
                } else if (currentProvider === 'ventusky') {
                    let vLayer = 'rain-3h';
                    if (currentOverlay === 'wind') vLayer = 'wind';
                    if (currentOverlay === 'temp') vLayer = 'temperature-2m';
                    if (currentOverlay === 'rain24') vLayer = 'rain-3h'; // Force rain-3h to ensure we see rain not temp
                    if (currentOverlay === 'rainTotal') vLayer = 'rain-3h'; // Force rain-3h (standard rain)
                    if (currentOverlay === 'satellite') vLayer = 'clouds';

                    // Removed hardcoded time parameter 't' to use current time
                    iframe.src = `https://www.ventusky.com/insert/?p=${lat};${lon};5&l=${vLayer}&w=0`;
                } else if (currentProvider === 'openweather') {
                    // OpenWeatherMap Interactive Map
                    iframe.src = `https://openweathermap.org/weathermap?basemap=map&cities=true&layer=precipitation&lat=${lat}&lon=${lon}&zoom=6`;
                } else if (currentProvider === 'meteoblue') {
                    // Meteoblue blocks direct generic embeds often. Use fallback.
                    iframe.style.display = 'none';
                    fallback.style.display = 'flex';
                    // Update fallback content dynamically
                    fallback.innerHTML = `
                    <i class="fas fa-wind" style="font-size:5rem; margin-bottom:20px; color:#0369a1;"></i>
                    <h3 style="margin:0 0 10px 0;">Abrir Meteoblue</h3>
                     <p style="max-width:400px; margin:0 auto 25px auto; color:#94a3b8;">
                        A visualização direta requer permissões de widget. Abra o mapa completo da Meteoblue em nova aba.
                    </p>
                    <a href="https://www.meteoblue.com/en/weather/webmap/beta/catal%c3%a3o_brazil_3466164" target="_blank" 
                       style="background:#0369a1; color:white; padding:12px 25px; border-radius:8px; text-decoration:none; font-weight:bold; font-size:1.1rem; transition:background 0.2s;">
                       <i class="fas fa-external-link-alt"></i> Acessar Meteoblue (Catalão)
                    </a>
                 `;
                } else if (currentProvider === 'zoom') {
                    iframe.style.display = 'none';
                    fallback.style.display = 'flex';
                    // Reset fallback content for Zoom
                    fallback.innerHTML = `
                    <i class="fas fa-globe-americas" style="font-size:5rem; margin-bottom:20px; color:#3b82f6;"></i>
                    <h3 style="margin:0 0 10px 0;">Abrir Zoom Earth</h3>
                    <p style="max-width:400px; margin:0 auto 25px auto; color:#94a3b8;">
                        O Zoom Earth não permite visualização direta dentro de outros sites (conexão recusada), mas você pode abrir a versão completa em nova aba.
                    </p>
                    <a href="https://zoom.earth/maps/satellite/#view=-18.166,-47.943,6z/overlays=rain,wind" target="_blank" 
                       style="background:#3b82f6; color:white; padding:12px 25px; border-radius:8px; text-decoration:none; font-weight:bold; font-size:1.1rem; transition:background 0.2s;">
                       <i class="fas fa-external-link-alt"></i> Acessar Satélite em HD
                    </a>
                 `;
                } else if (currentProvider === 'static') {
                    // Static Images Gallery
                    iframe.style.display = 'none';
                    const gallery = document.getElementById('static-gallery');
                    if (gallery) {
                        gallery.style.display = 'grid';
                        // Update timestamps to break cache
                        const ts = new Date().getTime();
                        document.getElementById('img-satelite-br').src = `https://cdn.star.nesdis.noaa.gov/GOES16/ABI/FD/GEOCOLOR/1808x1808.jpg?t=${ts}`;
                        document.getElementById('img-carta-sinotica').src = `https://www.marinha.mil.br/chm/sites/www.marinha.mil.br.chm/files/cartas-sinoticas/c00.jpg?t=${ts}`; // Carta 00Z as example, often fixed name
                    }
                }


                // Toggle Controls Visibility
                const controls = document.getElementById('map-controls-row');
                // Hide controls for Zoom, Static, and Meteoblue (since it uses fallback)
                if (currentProvider === 'zoom' || currentProvider === 'static' || currentProvider === 'meteoblue') {
                    if (controls) controls.style.display = 'none';
                    // Explicitly show gallery ONLY if static
                    const gallery = document.getElementById('static-gallery');
                    if (gallery) gallery.style.display = (currentProvider === 'static') ? 'grid' : 'none';

                    // Fallback only for zoom or meteoblue
                    const fallback = document.getElementById('zoom-earth-fallback');
                    if (fallback && (currentProvider === 'zoom' || currentProvider === 'meteoblue')) fallback.style.display = 'flex';
                    if (fallback && currentProvider === 'static') fallback.style.display = 'none';

                } else {
                    if (controls) controls.style.display = 'flex';
                    const gallery = document.getElementById('static-gallery');
                    if (gallery) gallery.style.display = 'none';
                }
            }, 100);
        };

        container.innerHTML = `
            <div class="clima-card">
                <div style="margin-bottom:15px;">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                        <h4 style="margin:0; color:#374151;">Mapa Clima / Imagens</h4>
                        <!-- Provider Selector -->
                        <div style="background:#e0f2fe; padding:4px; border-radius:6px; display:flex; gap:4px;">
                             <button class="btn-map-provider active" data-provider="windy" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:#0ea5e9; color:white;">Windy</button>
                             <button class="btn-map-provider" data-provider="ventusky" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:transparent; color:#0369a1;">Ventusky</button>
                             <button class="btn-map-provider" data-provider="meteoblue" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:transparent; color:#0369a1;">Meteoblue</button>
                             <button class="btn-map-provider" data-provider="openweather" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:transparent; color:#0369a1;">OpenWeather</button>
                             <button class="btn-map-provider" data-provider="zoom" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:transparent; color:#0369a1;">Zoom Earth</button>
                             <button class="btn-map-provider" data-provider="static" style="padding:6px 12px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.85rem; transition:all 0.2s; background:transparent; color:#0369a1;"><i class="fas fa-image"></i> Estáticas</button>
                        </div>
                    </div>
                
                    <div id="map-controls-row" style="display:flex; flex-wrap:wrap; gap:10px; align-items:center; margin-bottom:10px;">
                        
                        <!-- Model Selector (Windy/Ventusky) -->
                        <div style="background:#f1f5f9; padding:4px; border-radius:6px; display:flex; gap:4px;">
                            <span style="padding:6px; font-size:0.8rem; color:#64748b; font-weight:600;">Modelo:</span>
                            <button class="btn-map-model active" data-model="ecmwf" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.8rem; background:#fff; color:#0f172a; box-shadow:0 1px 2px rgba(0,0,0,0.1);">ECMWF</button>
                            <button class="btn-map-model" data-model="gfs" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-weight:600; font-size:0.8rem; background:transparent; color:#64748b;">GFS</button>
                        </div>

                        <!-- Layer Selector -->
                        <div style="background:#f1f5f9; padding:4px; border-radius:6px; display:flex; gap:4px; flex-wrap:wrap;">
                            <button class="btn-map-layer active" data-layer="rain" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:#fff; color:#0f172a; box-shadow:0 1px 2px rgba(0,0,0,0.1);"><i class="fas fa-umbrella"></i> Agora</button>
                            <button class="btn-map-layer" data-layer="rain24" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:transparent; color:#64748b;"><i class="fas fa-clock"></i> 24h</button>
                            <button class="btn-map-layer" data-layer="rainTotal" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:transparent; color:#64748b;"><i class="fas fa-calendar-week"></i> 10 Dias</button> <!-- Total -->
                            <button class="btn-map-layer" data-layer="wind" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:transparent; color:#64748b;"><i class="fas fa-wind"></i> Vento</button>
                            <button class="btn-map-layer" data-layer="temp" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:transparent; color:#64748b;"><i class="fas fa-temperature-high"></i> Temp</button>
                            <button class="btn-map-layer" data-layer="satellite" style="padding:4px 10px; border:none; border-radius:4px; cursor:pointer; font-size:0.8rem; background:transparent; color:#64748b;"><i class="fas fa-satellite"></i> Satélite</button>
                        </div>
                    </div>
                </div>
                
                <div style="width:100%; height:650px; border-radius:12px; overflow:hidden; background:#e2e8f0; position:relative;">
                    <iframe id="windy-iframe" width="100%" height="100%" src="" frameborder="0" allowfullscreen></iframe>
                    <!-- Fallback for Zoom Earth -->
                    <div id="zoom-earth-fallback" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background:linear-gradient(to bottom, #0f172a, #1e293b); color:white; flex-direction:column; align-items:center; justify-content:center; text-align:center;">
                        <i class="fas fa-globe-americas" style="font-size:5rem; margin-bottom:20px; color:#3b82f6;"></i>
                        <h3 style="margin:0 0 10px 0;">Abrir Zoom Earth</h3>
                        <p style="max-width:400px; margin:0 auto 25px auto; color:#94a3b8;">
                            O Zoom Earth não permite visualização direta dentro de outros sites (conexão recusada), mas você pode abrir a versão completa em nova aba.
                        </p>
                        <a href="https://zoom.earth/maps/satellite/#view=-18.166,-47.943,6z/overlays=rain,wind" target="_blank" 
                           style="background:#3b82f6; color:white; padding:12px 25px; border-radius:8px; text-decoration:none; font-weight:bold; font-size:1.1rem; transition:background 0.2s;">
                           <i class="fas fa-external-link-alt"></i> Acessar Satélite em HD
                        </a>
                    </div>
                    
                    <!-- Static Gallery -->
                    <div id="static-gallery" style="display:none; width:100%; height:100%; overflow-y:auto; background:white; padding:20px; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap:20px;">
                        <div style="background:#f8fafc; padding:10px; border-radius:8px; border:1px solid #e2e8f0; text-align:center;">
                            <h5 style="margin:0 0 10px 0; color:#475569;">Satélite GOES-16 (NOAA) - GeoColor (Full Disk)</h5>
                            <a href="https://cdn.star.nesdis.noaa.gov/GOES16/ABI/FD/GEOCOLOR/1808x1808.jpg" target="_blank" title="Clique para ampliar">
                                <img id="img-satelite-br" src="" onerror="this.src='https://cdn.star.nesdis.noaa.gov/GOES16/ABI/FD/GEOCOLOR/678x678.jpg'" style="width:100%; border-radius:4px; max-height:500px; object-fit:contain; cursor:zoom-in;" alt="Carregando Satélite NOAA...">
                            </a>
                            <p style="font-size:0.75rem; color:#94a3b8; margin:5px 0;">Atualizado a cada 10 min. (Clique para ampliar)</p>
                        </div>
                        <div style="background:#f8fafc; padding:10px; border-radius:8px; border:1px solid #e2e8f0; text-align:center;">
                            <h5 style="margin:0 0 10px 0; color:#475569;">Carta Sinótica (Pressão/Frentes) - Marinha</h5>
                            <img id="img-carta-sinotica" src="" style="width:100%; border-radius:4px; max-height:500px; object-fit:contain;" alt="Carregando Carta...">
                            <p style="font-size:0.75rem; color:#94a3b8; margin:5px 0;">Análise Técnica Oficial</p>
                        </div>
                    </div>
                </div>
                
                <div style="display:flex; justify-content:space-between; margin-top:10px; align-items:center;">
                    <p id="map-desc-text" style="text-align:center; color:#64748b; font-size:0.8rem; margin:0;">
                        Windy: A melhor ferramenta técnica para previsão detalhada.
                    </p>
                    <a href="https://www.tropicaltidbits.com/analysis/models/?model=ecmwf&region=samer&pkg=mslp_pcpn_frzn" target="_blank" 
                       style="color:#f59e0b; text-decoration:none; font-weight:bold; font-size:0.85rem; display:flex; align-items:center; gap:5px;">
                        <i class="fas fa-external-link-alt"></i> Análise Tropical Tidbits
                    </a>
                </div>
            </div>
        `;

        // Load Initial
        updateMap();

        // --- EVENTS ---

        // Provider Select
        container.querySelectorAll('.btn-map-provider').forEach(btn => {
            btn.addEventListener('click', (e) => {
                // Style Active
                container.querySelectorAll('.btn-map-provider').forEach(b => {
                    b.style.background = 'transparent';
                    b.style.color = '#0369a1';
                    b.classList.remove('active');
                });
                const t = e.currentTarget;
                t.style.background = '#0ea5e9';
                t.style.color = 'white';
                t.classList.add('active');

                currentProvider = t.dataset.provider;

                // Update Description
                const desc = document.getElementById('map-desc-text');
                if (currentProvider === 'windy') desc.innerText = 'Windy: A melhor ferramenta técnica para previsão detalhada.';
                if (currentProvider === 'ventusky') desc.innerText = 'Ventusky: Visualização fluida das correntes de ar e chuva.';
                if (currentProvider === 'zoom') desc.innerText = 'Zoom Earth: Visual de satélite realista (quase tempo real).';

                updateMap();
            });
        });

        // Model Select
        container.querySelectorAll('.btn-map-model').forEach(btn => {
            btn.addEventListener('click', (e) => {
                container.querySelectorAll('.btn-map-model').forEach(b => {
                    b.style.background = 'transparent';
                    b.style.color = '#64748b';
                    b.style.boxShadow = 'none';
                    b.classList.remove('active');
                });
                const t = e.currentTarget;
                t.style.background = '#fff';
                t.style.color = '#0f172a';
                t.style.boxShadow = '0 1px 2px rgba(0,0,0,0.1)';
                t.classList.add('active');

                currentModel = t.dataset.model;
                updateMap();
            });
        });

        // Layer Select
        container.querySelectorAll('.btn-map-layer').forEach(btn => {
            btn.addEventListener('click', (e) => {
                container.querySelectorAll('.btn-map-layer').forEach(b => {
                    b.style.background = 'transparent';
                    b.style.color = '#64748b';
                    b.style.boxShadow = 'none';
                    b.classList.remove('active');
                });
                const t = e.currentTarget;
                t.style.background = '#fff';
                t.style.color = '#0f172a';
                t.style.boxShadow = '0 1px 2px rgba(0,0,0,0.1)';
                t.classList.add('active');

                currentOverlay = t.dataset.layer;
                updateMap();
            });
        });
    }
};

